import { Box, Typography } from '@material-ui/core';
import React from 'react';
import styles from './style';
import theme from '../../../../theme/MyEirTheme';
import { useWindowDimension } from '../../../../hooks/windowDimensions';

const NoticeTile = props => {
    const classes = styles(theme);
    const [width] = useWindowDimension();

    return (
        <Box className={classes.notice}>
            <Typography variant='inputLabel' className={classes.text}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: width > 600 ? props?.desktopText : props?.mobileText,
                    }}
                />
            </Typography>
        </Box>
    );
};

export default NoticeTile;
